import styled from "styled-components";

export const Screen = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background: #000000;
  color: #ffffff;
`;

export const Content = styled.main`
  width: min(100%, 430px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Logo = styled.img`
  width: min(190px, 58vw);
  height: auto;
  margin-bottom: 44px;
`;

export const Title = styled.h1`
  margin: 0;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: clamp(2rem, 8vw, 3rem);
  font-weight: 700;
  line-height: 1.08;
`;

export const Body = styled.p`
  margin: 20px 0 0;
  color: rgba(255, 255, 255, 0.62);
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.55;
`;

export const Email = styled.a`
  color: #ffffff;
  font-weight: 700;
  text-decoration: none;
`;

export const PrimaryButton = styled.button`
  width: min(100%, 280px);
  min-height: 48px;
  margin-top: 34px;
  border: 0;
  border-radius: 12px;
  background: #ffffff;
  color: #000000;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition:
    transform 140ms ease,
    opacity 140ms ease;

  &:hover {
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.9);
    outline-offset: 3px;
  }
`;

export const SecondaryButton = styled.button`
  margin-top: 20px;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.72);
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 4px;
  cursor: pointer;

  &:hover {
    color: #ffffff;
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.9);
    outline-offset: 4px;
  }
`;